<section class="aic">

  <div class="aic__bar">
    <a href="#" class="aic__back" data-action="back">
      <i class="icon icon--arrow-left"></i> <%= _lcs( 'Alle KI-Kosten' ) %>
    </a>
  </div>

  <% if ( state !== 'ready' ) { %>
    <div class="dash-msg">
      <span class="dash-msg__icon"><i class="icon icon--<%= state === 'loading' ? 'sparkles' : 'triangle-alert' %>"></i></span>
      <h2><%= state === 'loading' ? _lcs( 'Lade KI-Kosten …' ) : ( state === 'notfound' ? _lcs( 'Gastgeber nicht gefunden' ) : _lcs( 'KI-Kosten konnten nicht geladen werden' ) ) %></h2>
      <p><%= state === 'notfound' ? _lcs( 'Diesen Gastgeber gibt es nicht (mehr).' ) : ( state === 'loading' ? _lcs( 'Einen Moment bitte.' ) : _lcs( 'Bitte versuche es später erneut.' ) ) %></p>
    </div>
  <% } else { %>

  <!-- ===== Who, and this month's budget ===== -->
  <div class="widget aic-head">
    <div class="aic-head__who">
      <span class="aic-head__icon"><i class="icon icon--<%= isPlatform ? 'layers' : 'briefcase' %>"></i></span>
      <div class="aic-head__text">
        <h2 class="aic-head__name"><%= head.name %></h2>
        <% if ( head.email ) { %>
          <a class="aic-head__mail" href="mailto:<%= head.email %>"><i class="icon icon--mail"></i> <%= head.email %></a>
        <% } %>
        <% if ( isDeleted ) { %>
          <p class="aic-head__sub"><%= _lcs( 'Diesen Gastgeber gibt es nicht mehr (z. B. eine nicht abgeschlossene Registrierung). Seine KI-Anfragen bleiben in der Kostenaufstellung.' ) %></p>
        <% } else if ( isPlatform ) { %>
          <p class="aic-head__sub"><%= _lcs( 'Alle KI-Anfragen ohne Gastgeber: Importe, nächtliche Übersetzungen und die Einrichtung neuer Unterkünfte bei der Registrierung. Diese Kosten trägt BELTURO, sie zählen gegen kein Gastgeber-Budget.' ) %></p>
        <% } else if ( head.houses.length ) { %>
          <div class="aic-head__houses">
            <% head.houses.forEach( function( h ) { %>
              <span class="pill <%= h.published ? 'pill--ok' : 'pill--neutral' %>"><i class="icon icon--building-2"></i> <%= h.name %></span>
            <% } ); %>
          </div>
        <% } %>
      </div>
    </div>

    <% if ( budget ) { %>
      <div class="aic-head__budget">
        <div class="acct__row">
          <span class="acct__label"><%= _lcs( 'Budget diesen Monat' ) %></span>
          <span class="acct__value"><%= budget.spent %> <small>/ <%= budget.limit %></small></span>
        </div>
        <span class="aic-meter aic-meter--lg aic-meter--<%= budget.tone %>"><span style="width: <%= Math.min( budget.percent, 100 ) %>%;"></span></span>
        <div class="acct__legend">
          <span><%= _lcs( '{percent} verbraucht', { percent: budget.percent + ' %' } ) %></span>
          <% if ( budget.isExhausted ) { %>
            <span class="pill pill--err"><i class="icon icon--triangle-alert"></i> <%= _lcs( 'Budget aufgebraucht' ) %></span>
          <% } else { %>
            <span><%= _lcs( 'noch {remaining} frei', { remaining: budget.remaining } ) %></span>
          <% } %>
        </div>
      </div>
    <% } %>
  </div>

  <section class="kpi-grid">
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Diesen Monat' ) %></span>
        <span class="kpi__icon"><i class="icon icon--wallet"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.month %></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--trending-up"></i> <span><%= kpi.forecast %></span></span>
    </div>
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Vormonat' ) %></span>
        <span class="kpi__icon kpi__icon--sand"><i class="icon icon--calendar"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.previous %></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--activity"></i> <span><%= kpi.previousSub %></span></span>
    </div>
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Letzte 12 Monate' ) %></span>
        <span class="kpi__icon"><i class="icon icon--badge-euro"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.total %></div>
      <span class="kpi__delta kpi__delta--flat"><i class="icon icon--activity"></i> <span><%= kpi.totalSub %></span></span>
    </div>
    <div class="kpi">
      <div class="kpi__top">
        <span class="kpi__label"><%= _lcs( 'Ø Kosten pro Anfrage' ) %></span>
        <span class="kpi__icon kpi__icon--sky"><i class="icon icon--gauge"></i></span>
      </div>
      <div class="kpi__value"><%= kpi.perRequest %></div>
      <span class="kpi__delta <%= kpi.errorClass %>"><i class="icon icon--triangle-alert"></i> <span><%= kpi.errors %></span></span>
    </div>
  </section>

  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--bar-chart-3"></i> <%= _lcs( 'Kosten pro Monat' ) %></h3>
      <span class="widget__note"><%= _lcs( 'Nach Funktion' ) %></span>
    </div>
    <div class="widget__body">
      <div class="chart aic__chart" data-id="chart-months"></div>
    </div>
  </div>

  <div class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--activity"></i> <%= _lcs( 'Kosten pro Tag' ) %></h3>
      <span class="widget__note"><%= _lcs( 'Letzte 60 Tage' ) %></span>
    </div>
    <div class="widget__body">
      <div class="chart aic__chart aic__chart--line" data-id="chart-days"></div>
    </div>
  </div>

  <div class="aic-cols">

    <div class="aic-main">
      <% if ( houses.length ) { %>
        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--building-2"></i> <%= _lcs( 'Nach Unterkunft' ) %></h3>
            <span class="widget__note"><%= _lcs( 'Letzte 12 Monate' ) %></span>
          </div>
          <div class="widget__body widget__body--flush">
            <table class="an-table">
              <thead>
                <tr>
                  <th><%= _lcs( 'Unterkunft' ) %></th>
                  <th class="aic-table__budget"><%= _lcs( 'Anteil' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Diesen Monat' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Anfragen' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Kosten' ) %></th>
                </tr>
              </thead>
              <tbody>
                <% houses.forEach( function( h ) { %>
                  <tr>
                    <td class="an-table__name"><%= h.name %></td>
                    <td class="aic-table__budget">
                      <span class="aic-meter"><span style="width: <%= h.percent %>%;"></span></span>
                      <span class="aic-meter__text"><%= h.percent %> %</span>
                    </td>
                    <td class="an-table__num"><%= h.month %></td>
                    <td class="an-table__num"><%= h.requests %></td>
                    <td class="an-table__num aic-table__cost"><%= h.cost %></td>
                  </tr>
                <% } ); %>
              </tbody>
            </table>
          </div>
        </div>
      <% } %>

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--list"></i> <%= _lcs( 'Letzte Anfragen' ) %></h3>
          <span class="widget__note"><%= _lcs( 'die neuesten {count}', { count: calls.length } ) %></span>
        </div>
        <div class="widget__body widget__body--flush">
          <% if ( calls.length === 0 ) { %>
            <p class="aic__empty"><%= _lcs( 'Noch keine KI-Anfragen.' ) %></p>
          <% } else { %>
            <div class="aic__scroll">
              <table class="an-table aic-calls">
                <thead>
                  <tr>
                    <th><%= _lcs( 'Zeitpunkt' ) %></th>
                    <th><%= _lcs( 'Funktion' ) %></th>
                    <% if ( !isPlatform ) { %><th><%= _lcs( 'Unterkunft' ) %></th><% } %>
                    <th><%= _lcs( 'Modell' ) %></th>
                    <th class="an-table__num"><%= _lcs( 'Tokens ein / aus' ) %></th>
                    <th class="an-table__num"><%= _lcs( 'Dauer' ) %></th>
                    <th class="an-table__num"><%= _lcs( 'Kosten' ) %></th>
                  </tr>
                </thead>
                <tbody>
                  <% calls.forEach( function( c ) { %>
                    <tr class="<%= c.isError ? 'aic-calls__row--error' : '' %>">
                      <td class="aic-calls__time"><%= c.time %></td>
                      <td>
                        <span class="aic-dot" style="background: <%= c.color %>;"></span> <%= c.feature %>
                        <% if ( c.isError ) { %> <span class="pill pill--err"><%= _lcs( 'Fehler' ) %></span><% } %>
                        <% if ( c.user ) { %><br><span class="an-table__slug"><%= c.user %></span><% } %>
                      </td>
                      <% if ( !isPlatform ) { %><td><%= c.house %></td><% } %>
                      <td class="aic-table__mono"><%= c.model %></td>
                      <td class="an-table__num"><%= c.tokens %></td>
                      <td class="an-table__num"><%= c.duration %></td>
                      <td class="an-table__num"><%= c.cost %></td>
                    </tr>
                  <% } ); %>
                </tbody>
              </table>
            </div>
          <% } %>
        </div>
      </div>
    </div>

    <div class="aic-side">
      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--sparkles"></i> <%= _lcs( 'Nach Funktion' ) %></h3>
          <span class="widget__note"><%= _lcs( 'Letzte 12 Monate' ) %></span>
        </div>
        <div class="widget__body">
          <% if ( features.length === 0 ) { %>
            <p class="aic__empty aic__empty--inline"><%= _lcs( 'Noch keine KI-Anfragen.' ) %></p>
          <% } else { %>
            <div class="chart aic__chart aic__chart--donut" data-id="chart-features"></div>
            <ul class="aic-legend">
              <% features.forEach( function( f ) { %>
                <li class="aic-legend__row">
                  <span class="aic-dot" style="background: <%= f.color %>;"></span>
                  <span class="aic-legend__label"><%= f.label %></span>
                  <span class="aic-legend__meta"><%= f.requests %></span>
                  <span class="aic-legend__value"><%= f.cost %></span>
                </li>
              <% } ); %>
            </ul>
          <% } %>
        </div>
      </div>

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--layers"></i> <%= _lcs( 'Modelle' ) %></h3>
          <span class="widget__note"><%= _lcs( 'Letzte 12 Monate' ) %></span>
        </div>
        <div class="widget__body widget__body--flush">
          <% if ( models.length === 0 ) { %>
            <p class="aic__empty"><%= _lcs( 'Noch keine KI-Anfragen.' ) %></p>
          <% } else { %>
            <table class="an-table">
              <thead>
                <tr>
                  <th><%= _lcs( 'Modell' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Anfragen' ) %></th>
                  <th class="an-table__num"><%= _lcs( 'Kosten' ) %></th>
                </tr>
              </thead>
              <tbody>
                <% models.forEach( function( m ) { %>
                  <tr>
                    <td class="aic-table__mono"><%= m.model %></td>
                    <td class="an-table__num"><%= m.requests %></td>
                    <td class="an-table__num"><%= m.cost %></td>
                  </tr>
                <% } ); %>
              </tbody>
            </table>
            <p class="aic__foot"><%= tokenNote %></p>
          <% } %>
        </div>
      </div>
    </div>

  </div>

  <% } %>
</section>
